/**
 * @generated SignedSource<<2631ace7906f2dfbab9a5de981482dfb>>
 * @relayHash ef9d214fb72710f0604b77c39b9f3be4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8ca052a55e5704a38799c86ee034c9b4f155be0b8ce000ad09b8da69695bc0fa

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceBlogPostStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluenceContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluenceContentType = "ATTACHMENT" | "BLOG_POST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type ConfluencePageStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type HomeRecentActivityQuery$variables = {
  after?: string | null;
  cloudId: string;
  eventTypes?: ReadonlyArray<string> | null;
  first?: number | null;
  objectTypes?: ReadonlyArray<string> | null;
  products?: ReadonlyArray<string> | null;
};
export type HomeRecentActivityQuery$data = {
  readonly activity: {
    readonly myActivity: {
      readonly all: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly event: {
              readonly eventType: string;
              readonly id: string;
              readonly timestamp: AGG$DateTime;
            };
            readonly id: string;
            readonly object: {
              readonly data: {
                readonly blogStatus?: ConfluenceBlogPostStatus | null;
                readonly body?: {
                  readonly excerpt: string | null;
                } | null;
                readonly commentCountSummary?: {
                  readonly total: number | null;
                } | null;
                readonly commentId?: string | null;
                readonly container?: {
                  readonly blogStatus?: ConfluenceBlogPostStatus | null;
                  readonly body?: {
                    readonly excerpt: string | null;
                  } | null;
                  readonly commentCountSummary?: {
                    readonly total: number | null;
                  } | null;
                  readonly createdAt?: string | null;
                  readonly editorVersion?: ReadonlyArray<{
                    readonly value: string;
                  } | null> | null;
                  readonly id?: string;
                  readonly likesSummary?: {
                    readonly count: number | null;
                  } | null;
                  readonly links?: {
                    readonly editUi: string | null;
                    readonly webUi: string | null;
                  } | null;
                  readonly metadata?: {
                    readonly titleEmojiDraft: {
                      readonly value: string | null;
                    } | null;
                    readonly titleEmojiPublished: {
                      readonly value: string | null;
                    } | null;
                  } | null;
                  readonly pageStatus?: ConfluencePageStatus | null;
                  readonly space?: {
                    readonly alias: string | null;
                    readonly id: string;
                    readonly key: string | null;
                    readonly name: string | null;
                  } | null;
                  readonly status?: ConfluenceContentStatus | null;
                  readonly subtype?: ConfluencePageSubType | null;
                  readonly title?: string | null;
                  readonly type?: ConfluenceContentType | null;
                  readonly viewer?: {
                    readonly favoritedSummary: {
                      readonly isFavorite: boolean;
                    } | null;
                  } | null;
                } | null;
                readonly createdAt?: string | null;
                readonly displayName?: string | null;
                readonly editorVersion?: ReadonlyArray<{
                  readonly value: string;
                } | null> | null;
                readonly id?: string;
                readonly likesSummary?: {
                  readonly count: number | null;
                } | null;
                readonly links?: {
                  readonly editUi: string | null;
                  readonly webUi: string | null;
                } | null;
                readonly metadata?: {
                  readonly titleEmojiDraft: {
                    readonly value: string | null;
                  } | null;
                  readonly titleEmojiPublished: {
                    readonly value: string | null;
                  } | null;
                } | null;
                readonly pageStatus?: ConfluencePageStatus | null;
                readonly provider?: {
                  readonly name: string | null;
                } | null;
                readonly space?: {
                  readonly alias: string | null;
                  readonly id: string;
                  readonly key: string | null;
                  readonly name: string | null;
                } | null;
                readonly status?: ConfluenceContentStatus | null;
                readonly subtype?: ConfluencePageSubType | null;
                readonly title?: string | null;
                readonly type?: ConfluenceContentType | null;
                readonly url?: string | null;
                readonly viewer?: {
                  readonly favoritedSummary: {
                    readonly isFavorite: boolean;
                  } | null;
                } | null;
              } | null;
              readonly id: string;
            };
          };
        }>;
        readonly pageInfo: {
          readonly endCursor: string | null;
          readonly hasNextPage: boolean;
        };
      };
    } | null;
  } | null;
};
export type HomeRecentActivityQuery = {
  response: HomeRecentActivityQuery$data;
  variables: HomeRecentActivityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventTypes"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectTypes"
},
v5 = {
  "defaultValue": [
    "CONFLUENCE"
  ],
  "kind": "LocalArgument",
  "name": "products"
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "eventTypes",
            "variableName": "eventTypes"
          },
          {
            "kind": "Variable",
            "name": "objectTypes",
            "variableName": "objectTypes"
          },
          {
            "kind": "Variable",
            "name": "products",
            "variableName": "products"
          }
        ],
        "kind": "ObjectValue",
        "name": "arguments"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "rootContainerIds.0",
            "variableName": "cloudId"
          }
        ],
        "kind": "ListValue",
        "name": "rootContainerIds"
      },
      {
        "kind": "Literal",
        "name": "type",
        "value": "AND"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "title"
},
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v12 = {
  "alias": "pageStatus",
  "kind": "ScalarField",
  "name": "status"
},
v13 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v14 = {
  "kind": "ScalarField",
  "name": "webUi"
},
v15 = [
  (v14/*: any*/),
  {
    "kind": "ScalarField",
    "name": "editUi"
  }
],
v16 = {
  "concreteType": "ConfluencePageLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v15/*: any*/)
},
v17 = {
  "concreteType": "ConfluenceBodies",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "excerpt"
    }
  ]
},
v18 = [
  {
    "concreteType": "ConfluenceFavoritedSummary",
    "kind": "LinkedField",
    "name": "favoritedSummary",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isFavorite"
      }
    ]
  }
],
v19 = {
  "concreteType": "ConfluencePageViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v18/*: any*/)
},
v20 = {
  "concreteType": "ConfluenceCommentCountSummary",
  "kind": "LinkedField",
  "name": "commentCountSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "total"
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "name"
},
v22 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    (v21/*: any*/)
  ]
},
v23 = {
  "concreteType": "ConfluenceLikesSummary",
  "kind": "LinkedField",
  "name": "likesSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "count"
    }
  ]
},
v24 = [
  {
    "kind": "Literal",
    "name": "keys",
    "value": [
      "editor"
    ]
  }
],
v25 = {
  "kind": "ScalarField",
  "name": "value"
},
v26 = [
  (v25/*: any*/)
],
v27 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiDraft",
      "plural": false,
      "selections": (v26/*: any*/)
    },
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiPublished",
      "plural": false,
      "selections": (v26/*: any*/)
    }
  ]
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    {
      "alias": "editorVersion",
      "args": (v24/*: any*/),
      "concreteType": "ConfluencePageProperty",
      "kind": "LinkedField",
      "name": "properties",
      "plural": true,
      "selections": (v26/*: any*/),
      "storageKey": "properties(keys:[\"editor\"])"
    },
    (v27/*: any*/)
  ],
  "type": "ConfluencePage"
},
v29 = {
  "alias": "blogStatus",
  "kind": "ScalarField",
  "name": "status"
},
v30 = {
  "concreteType": "ConfluenceBlogPostLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v15/*: any*/)
},
v31 = {
  "concreteType": "ConfluenceBlogPostViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v18/*: any*/)
},
v32 = {
  "alias": "editorVersion",
  "args": (v24/*: any*/),
  "concreteType": "ConfluenceBlogPostProperty",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": (v26/*: any*/),
  "storageKey": "properties(keys:[\"editor\"])"
},
v33 = {
  "kind": "ScalarField",
  "name": "status"
},
v34 = [
  (v14/*: any*/)
],
v35 = {
  "concreteType": "ConfluenceContentViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v18/*: any*/)
},
v36 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v33/*: any*/),
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v34/*: any*/)
    },
    (v35/*: any*/),
    (v20/*: any*/),
    (v22/*: any*/)
  ],
  "type": "ConfluenceWhiteboard"
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v33/*: any*/),
    {
      "concreteType": "ConfluenceDatabaseLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v34/*: any*/)
    },
    (v35/*: any*/),
    (v20/*: any*/),
    (v22/*: any*/)
  ],
  "type": "ConfluenceDatabase"
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v33/*: any*/),
    {
      "concreteType": "ConfluenceEmbedLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v34/*: any*/)
    },
    (v35/*: any*/),
    (v20/*: any*/),
    (v22/*: any*/),
    (v27/*: any*/)
  ],
  "type": "ConfluenceEmbed"
},
v39 = [
  (v8/*: any*/),
  {
    "kind": "ScalarField",
    "name": "displayName"
  },
  {
    "kind": "ScalarField",
    "name": "url"
  },
  {
    "concreteType": "ExternalProvider",
    "kind": "LinkedField",
    "name": "provider",
    "plural": false,
    "selections": [
      (v21/*: any*/)
    ]
  }
],
v40 = {
  "kind": "InlineFragment",
  "selections": (v39/*: any*/),
  "type": "ExternalDocument"
},
v41 = {
  "kind": "InlineFragment",
  "selections": (v39/*: any*/),
  "type": "ExternalRemoteLink"
},
v42 = {
  "kind": "InlineFragment",
  "selections": (v39/*: any*/),
  "type": "ExternalPullRequest"
},
v43 = {
  "kind": "InlineFragment",
  "selections": (v39/*: any*/),
  "type": "ExternalWorkItem"
},
v44 = {
  "kind": "ScalarField",
  "name": "commentId"
},
v45 = [
  (v8/*: any*/),
  (v44/*: any*/),
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v28/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v17/*: any*/),
          (v31/*: any*/),
          (v20/*: any*/),
          (v22/*: any*/),
          (v32/*: any*/),
          (v27/*: any*/)
        ],
        "type": "ConfluenceBlogPost"
      },
      (v36/*: any*/)
    ]
  }
],
v46 = {
  "concreteType": "ActivityEvent",
  "kind": "LinkedField",
  "name": "event",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "timestamp"
    },
    {
      "kind": "ScalarField",
      "name": "eventType"
    }
  ]
},
v47 = {
  "concreteType": "ActivityPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v49 = [
  (v25/*: any*/),
  (v8/*: any*/)
],
v50 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    {
      "alias": "editorVersion",
      "args": (v24/*: any*/),
      "concreteType": "ConfluencePageProperty",
      "kind": "LinkedField",
      "name": "properties",
      "plural": true,
      "selections": (v49/*: any*/),
      "storageKey": "properties(keys:[\"editor\"])"
    },
    (v27/*: any*/)
  ],
  "type": "ConfluencePage"
},
v51 = {
  "alias": "editorVersion",
  "args": (v24/*: any*/),
  "concreteType": "ConfluenceBlogPostProperty",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": (v49/*: any*/),
  "storageKey": "properties(keys:[\"editor\"])"
},
v52 = [
  (v8/*: any*/)
],
v53 = {
  "kind": "InlineFragment",
  "selections": (v52/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v54 = [
  (v8/*: any*/),
  (v44/*: any*/),
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v48/*: any*/),
      (v50/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v17/*: any*/),
          (v31/*: any*/),
          (v20/*: any*/),
          (v22/*: any*/),
          (v51/*: any*/),
          (v27/*: any*/)
        ],
        "type": "ConfluenceBlogPost"
      },
      (v36/*: any*/),
      (v53/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeRecentActivityQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "args": (v6/*: any*/),
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "concreteType": "ActivityObject",
                            "kind": "LinkedField",
                            "name": "object",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v29/*: any*/),
                                      (v13/*: any*/),
                                      (v30/*: any*/),
                                      (v17/*: any*/),
                                      (v31/*: any*/),
                                      (v20/*: any*/),
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v32/*: any*/),
                                      (v27/*: any*/)
                                    ],
                                    "type": "ConfluenceBlogPost"
                                  },
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v45/*: any*/),
                                    "type": "ConfluenceInlineComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v45/*: any*/),
                                    "type": "ConfluenceFooterComment"
                                  }
                                ]
                              }
                            ]
                          },
                          (v46/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v47/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeRecentActivityQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "args": (v6/*: any*/),
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "concreteType": "ActivityObject",
                            "kind": "LinkedField",
                            "name": "object",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v48/*: any*/),
                                  (v50/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v29/*: any*/),
                                      (v13/*: any*/),
                                      (v30/*: any*/),
                                      (v17/*: any*/),
                                      (v31/*: any*/),
                                      (v20/*: any*/),
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v51/*: any*/),
                                      (v27/*: any*/)
                                    ],
                                    "type": "ConfluenceBlogPost"
                                  },
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v54/*: any*/),
                                    "type": "ConfluenceInlineComment"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v54/*: any*/),
                                    "type": "ConfluenceFooterComment"
                                  },
                                  (v53/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v52/*: any*/),
                                    "type": "DevOpsPullRequestDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v52/*: any*/),
                                    "type": "MercuryPortfolio"
                                  }
                                ]
                              }
                            ]
                          },
                          (v46/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v47/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ef9d214fb72710f0604b77c39b9f3be4",
    "id": "8ca052a55e5704a38799c86ee034c9b4f155be0b8ce000ad09b8da69695bc0fa",
    "metadata": {},
    "name": "HomeRecentActivityQuery",
    "operationKind": "query",
    "text": "query HomeRecentActivityQuery($cloudId:ID!,$first:Int,$after:String,$products:[String!]=[\"CONFLUENCE\"],$eventTypes:[String!],$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:$products,objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ExternalDocument{id,displayName,url,provider{name}},...on ExternalRemoteLink{id,displayName,url,provider{name}},...on ExternalPullRequest{id,displayName,url,provider{name}},...on ExternalWorkItem{id,displayName,url,provider{name}},...on ConfluenceInlineComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on ConfluenceFooterComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}},event{id,timestamp,eventType}}},pageInfo{hasNextPage,endCursor}}}}}"
  }
};
})();

(node as any).hash = "e4ab3a2dba3e8649a0ea5abf39bd4a41";

export default node;
